/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { ApprovalsAppSidebarContainer as ApprovalsAppSidebar } from './ApprovalsAppSidebar.container';
